'use client';

import ErrorCont from '@wconcept/wconcept-ui-renewal/components/molecules/ErrorCont';
import { useRouter } from 'next/navigation';

const errorMsg = {
  type: '500',
  title: '현재 서비스 접속이 <br class="inline-pc" />원활하지 않습니다.',
  detail: '이용에 불편을 드려 죄송합니다. <br />잠시 후 다시 시도해 주세요.',
  linkText: '다시 시도하기',
  logo: true,
};

function ErrorPage() {
  // EVENT HANDLER : 링크클릭
  const router = useRouter();
  const onClickLink = async () => {
    router.refresh();
  };

  return (
    <ErrorCont
      type={errorMsg.type}
      title={errorMsg.title}
      detail={errorMsg.detail}
      linkText={errorMsg.linkText}
      logo={errorMsg.logo}
      onClick={() => {
        onClickLink();
      }}
    />
  );
}

export default ErrorPage;
